module.exports = __webpack_public_path__ + "static/img/user_story_banner_mobile_en.e18f63c8.jpg";